import type { LayoutSettings } from '../../types.ts';
import { useIPO } from './useIPO.ts';

export default (): LayoutSettings => {
    const { diagnosis } = useIPO();

    return diagnosis.layout.settings;
};
